"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.content.placeholder': 'Wprowadź treść wiedzy',
};
